<template>
    <a :href="downloadPath" v-text="name" :download="name"></a>
</template>
<script>
    export default {
        props: {
            fileId: {
                type: Number,
                required: true,
            },
            name: {
                type: String,
                default() {
                    return 'download'
                }
            }
        },
        computed: {
            downloadPath() {
                return route('resource.files.show', {
                    file: this.fileId,
                })
            },
        }
    }
</script>